cacheWrites